import { render, staticRenderFns } from "./Abnormalpackage.vue?vue&type=template&id=d1878fa8&scoped=true&"
import script from "./Abnormalpackage.vue?vue&type=script&lang=js&"
export * from "./Abnormalpackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1878fa8",
  null
  
)

export default component.exports